import Vue from 'vue'
import { API_URL } from '../../api'
import ProjectRatingsFilter from '../../filters/ProjectRatingsFilter';
const state = {
    projectRatingCreate: {
        createdProjectRating: null,
        creatingProjectRating: false,
        createProjectRatingStatus: null
    },
    projectRatingUpdate: {
        updatedProjectRating: null,
        updatingProjectRating: false,
        updateProjectRatingStatus: null
    },
    projectRatingDelete: {
        deletingProjectRating: false,
        deleteProjectRatingStatus: null
    },
    projectRatingSearch: {
        projectRatings: [],
        searchingProjectRatings: false,
        searchProjectRatingStatus: null
    },
}
const mutations = {
    ['SET_PROJECT_RATING_CREATE'](state, change) {
        state.projectRatingCreate = { ...state.projectRatingCreate, ...change };
    },
    ['SET_PROJECT_RATING_UPDATE'](state, change) {
        state.projectRatingUpdate = { ...state.projectRatingUpdate, ...change };
    },
    ['SET_PROJECT_RATING_DELETE'](state, change) {
        state.projectRatingDelete = { ...state.projectRatingDelete, ...change };
    },
    ['SET_PROJECT_RATING_SEARCH'](state, change) {
        state.projectRatingSearch = { ...state.projectRatingSearch, ...change };
    }
}
const actions = {
    createProjectRating: ({ commit }, payload) => {
        commit('SET_PROJECT_RATING_CREATE', { createProjectRatingStatus: null, createdProjectRating: null, creatingProjectRating: true })
        return Vue.http.post(API_URL + '/projectRatings/create', payload).then(response => {
            commit('SET_PROJECT_RATING_CREATE', { createProjectRatingStatus: 'success', createdProjectRating: response.body.results.projectRating });
        }).catch(response => {
            commit('SET_PROJECT_RATING_CREATE', { createProjectRatingStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_RATING_CREATE', { creatingProjectRating: false });
        });
    },
    updateProjectRating: ({ commit }, payload) => {
        commit('SET_PROJECT_RATING_UPDATE', { updateProjectRatingStatus: null, updatedProjectRating: null, updatingProjectRating: true })
        return Vue.http.post(API_URL + '/projectRatings/update/' + payload.id, payload)
            .then(response => {
                commit('SET_PROJECT_RATING_UPDATE', { updateProjectRatingStatus: 'success', updatedProjectRating: response.body.results.projectRating });
            })
            .catch(response => {
                commit('SET_PROJECT_RATING_UPDATE', { updateProjectRatingStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_PROJECT_RATING_UPDATE', { updatingProjectRating: false });
            })
    },
    deleteProjectRating: ({ commit }, id) => {
        commit('SET_PROJECT_RATING_DELETE', { deleteProjectRatingStatus: null, deletedProjectRating: null, deletingProjectRating: true })
        return Vue.http.delete(API_URL + '/projectRatings/delete/' + id).then(response => {
            commit('SET_PROJECT_RATING_DELETE', { deleteProjectRatingStatus: 'success' });
        }).catch(response => {
            commit('SET_PROJECT_RATING_DELETE', { deleteProjectRatingStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_RATING_DELETE', { deletingProjectRating: false });
        })
    },
    searchProjectRatings: ({ commit }, payload = { filter: ProjectRatingsFilter(), resultMode: 'default' }) => {
        commit('SET_PROJECT_RATING_SEARCH', { searchProjectRatingStatus: null, searchProjectRating: null, searchingProjectRatings: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/projectRatings' + params).then(response => {
            commit('SET_PROJECT_RATING_SEARCH', { searchProjectRatingStatus: 'success', projectRatings: response.body.results.projectRatings });
        }).catch(response => {
            commit('SET_PROJECT_RATING_SEARCH', { searchProjectRatingStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_RATING_SEARCH', { searchingProjectRatings: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/projectRatingStore.js